export enum ExperienceTypes {
  GROUP = 1,
  PRIVATE = 0,
  TICKET = 3,
  TOUR = 2,
  INDEPENDENT_WALK = 4,
  TRANSFER_SERVICE = 5,
}

export enum ExperienceStringTypes {
  GROUP = 'group',
  PRIVATE = 'private',
  TICKET = 'ticket',
  TOUR = 'tour',
  INDEPENDENT_WALK = 'independent_walk',
  TRANSFER_SERVICE = 'transfer_service',
}

export const stringToExperienceType = (
  value: 'group' | 'private' | 'ticket' | 'tour' | 'independent_walk' | 'transfer_service',
): ExperienceTypes => {
  switch (value) {
    case 'group':
      return ExperienceTypes.GROUP;
    case 'private':
      return ExperienceTypes.PRIVATE;
    case 'ticket':
      return ExperienceTypes.TICKET;
    case 'tour':
      return ExperienceTypes.TOUR;
    case 'independent_walk':
      return ExperienceTypes.INDEPENDENT_WALK;
    case 'transfer_service':
      return ExperienceTypes.TRANSFER_SERVICE;
    default:
      throw new Error('unexpected experience type');
  }
};
